import React, { createContext, type ReactNode, useContext } from 'react'

import { type Shipment } from '../../../shipments/domain/Shipment'
import { useChat, type UseChatReturn } from './hooks/useChat'
import { Session } from './Session'

const ChatContext = createContext<UseChatReturn | undefined>(undefined)

export function useChatContext(): UseChatReturn {
  const context = useContext(ChatContext)

  if (!context) {
    throw new Error('useChatContext must be used within a ChatContextProvider')
  }

  return context
}

export function ChatContextProvider({
  children,
  shipment,
}: {
  children: ReactNode
  shipment: Shipment
}) {
  const chat = useChat({ shipment })

  return (
    <ChatContext.Provider value={chat}>
      <Session>{children}</Session>
    </ChatContext.Provider>
  )
}
